import React, { useEffect, useRef, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import '../../../Static/priceinfo.css';
import { fetchJobworkPaymentData } from '../../../Store/PHPSlice/Jobwork/jobworkApi';
import { selectJobworkPaymentData } from '../../Selectors/JobworkSelector/JobworkSelect';
import { Pending } from '@mui/icons-material';

const JobwkPayView = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        jobId: Id,
        dt: '',
        fdt: '',
        todt: '',
        departId: '',
        empId: '',
        empNm: '',
        jobMemo: '',
        totqty: '',
        totamt: '',
        gst: 5,
        gstAmt: '',
        netAmt: '',
        dedAmt: 0,
        finalAmt: '',
        pay_sts: ''
    });
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    const [jobwork, setJobwork] = useState([]);

    const [extraAmt, setExtraAmt] = useState([]);
    const jobworklist = useSelector(selectJobworkPaymentData);
    // console.log(jobworklist)
    useEffect(() => {
        dispatch(fetchJobworkPaymentData(Id));
    }, [Id]);

    useEffect(() => {
        if (jobworklist?.data) {
            const data2 = jobworklist?.data;
            setFormData(prev => ({
                ...prev,
                dedAmt: data2.deamt,
                dt: data2.dt,
                empId: data2.empId,
                empNm: data2.empNm,
                fdt: data2.fdt,
                gst: data2.gst,
                gstAmt: data2.gstamt,
                jobMemo: data2.jobMemo,
                netAmt: data2.netamt,
                finalAmt: data2.payableamt,
                todt: data2.tdt,
                totamt: data2.totamt,
                totqty: data2.totqty,
                pay_sts: data2.pay_sts
            }));
        }
        if (jobworklist?.jobInfo?.length > 0) {
            const values = jobworklist?.jobInfo;
            setJobwork(values);
        }
        if (jobworklist?.jobdedamt?.length > 0) {
            const dedvalues = jobworklist?.jobdedamt;
            setExtraAmt(dedvalues);
        }
    }, [jobworklist]);
    
    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Jobwork Payment Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>

                                    <td style={{ width: '200px' }}>Vocher No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.jobMemo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>From Date</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.fdt}</td>

                                    <td style={{ width: '200px' }}>To Date</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.todt}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Employee</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Payment Status</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', color: formData.pay_sts === '1' ? 'green' : 'red', fontSize:'1rem' }} className='dark-color'>{formData.pay_sts === '1' ? 'Paid' : 'Pending'}</td>
                                </tr>

                            </tbody>
                        </table>


                        {jobwork?.length > 0 ?
                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>
                                    <TableHead>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Memo</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>PI Ref. No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Item</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Total Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Rate</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Extra</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Amount</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            jobwork?.map((job, jobIndex) => (
                                                <TableRow key={jobIndex}>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{jobIndex + 1}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{job.stMemo}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{job.piMemo}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{job.itemNm}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{job.qty}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                        {job.rate}
                                                    </TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                        {job.extra}
                                                    </TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{job.amt}</TableCell>
                                                </TableRow>
                                            ))
                                        }

                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                Total
                                            </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{formData.totqty} </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold' }} align='center'>{formData.totamt}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                GST
                                            </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>

                                                {formData.gst} %

                                            </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold' }} align='center'>{formData.gstAmt} </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                Net Amt
                                            </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold' }} align='center'> {formData.netAmt}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                Deduction Amt.
                                            </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                {formData.dedAmt}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold' }} align='center'>
                                                Payable Amt.
                                            </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'> </TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontWeight: 'bold' }} align='center'> {formData.finalAmt}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer> : null
                        }
                        {
                            extraAmt?.length > 0 &&
                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>

                                    <TableHead>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'> </TableCell>
                                        {extraAmt?.map((item, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row' key={index}>{item.paytype}</TableCell>
                                        ))}
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Total</TableCell>
                                            {extraAmt?.map((item, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{item.actamt}</TableCell>
                                            ))}
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Less</TableCell>
                                            {extraAmt?.map((item, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                    {item.dedamt}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Balance</TableCell>
                                            {extraAmt?.map((item, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                    {item.bal}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableBody>

                                </Table>
                            </TableContainer>

                        }


                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
}

export default JobwkPayView;
